import React from 'react';
import { getSocialImpressionSource } from 'js/social/ImpressionHelper';

export type CardType =
  | 'discover'
  | 'bulk_follow'
  | 'swp_takeover'
  | 'swp_sidebar'
  | 'profile_similar_people';

// Helper method to get the list view modal header text based on the card type
export const getListModalHeader = (cardType: CardType, topicName?: string) => {
  switch (cardType) {
    case 'discover':
      return (
        <>Follow academics to stay up-to-date with the latest&nbsp;research</>
      );
    case 'bulk_follow':
      // Topic name should always be present for bulk follow, but just in case
      if (!topicName) {
        return null;
      }
      return (
        <>
          We found a set of academics related to
          <br />
          <span style={{ fontWeight: 500 }}>{topicName}</span>
        </>
      );
    case 'swp_takeover':
    case 'swp_sidebar':
      // Topic name should always be present for swp bulk follow tests, but just in case
      if (!topicName) {
        return null;
      }
      return (
        <>
          Follow <span style={{ fontWeight: 500 }}>{topicName}</span> academics
        </>
      );
    case 'profile_similar_people':
      return (
        <>
          Follow more people like{' '}
          <span style={{ fontWeight: 500 }}>{topicName}</span>
        </>
      );
    default:
      return null;
  }
};

// Helper method to generate the impression source for follow buttons in the list view modal
export const getListModalImpressionSource = (
  cardType: CardType,
  ctaType: 'follow' | 'follow_A',
) => {
  switch (cardType) {
    case 'discover':
      return getSocialImpressionSource('home', 'discover_modal', ctaType);
    case 'bulk_follow':
      return getSocialImpressionSource('home', 'bulk_follow_modal', ctaType);
    case 'swp_takeover':
      return `swp_bulk_follow_takeover_${ctaType}`;
    case 'swp_sidebar':
      return `swp_bulk_follow_sidebar_${ctaType}`;
    default:
      return '';
  }
};

// Helper method to generate the following source
export const getFollowingSource = (cardType: CardType) => {
  switch (cardType) {
    case 'discover':
      return 'big_card_discover_suggestion';
    case 'bulk_follow':
      return 'big_card_bulk_follow_suggestion';
    case 'swp_takeover':
      return 'swp_bulk_follow_takeover';
    case 'swp_sidebar':
      return 'swp_bulk_follow_sidebar';
    case 'profile_similar_people':
      return 'profile_similar_people';
    default:
      return '';
  }
};
